import { monadClient } from './client'

// ---------------------------------------------------------------------------
// SEN-1733 cold read 4 — the chip endpoint caps a request at 1000 record ids
// (monad/api/v1/records.py::_CHIPS_CAP; 422 above it — annotate, don't truncate).
// A frame whose set columns reference more than that made ONE oversized
// request, which threw; the query's isError was never read, and every marker
// silently degraded to a plain dot. Chunking is the caller's job, and the
// number here mirrors the server's — one place, named.
// ---------------------------------------------------------------------------
export const CHIPS_BATCH = 1000

export async function fetchChipsInBatches(
  slug: string, ids: string[],
): Promise<{ chips: Record<string, { kenning: string; icon: string | null; color: string | null }>; failedBatches: number }> {
  const batches: string[][] = []
  for (let i = 0; i < ids.length; i += CHIPS_BATCH) batches.push(ids.slice(i, i + CHIPS_BATCH))
  // Re-read: one failed batch must not discard the batches that succeeded —
  // a 1,200-id portfolio kept 0 labels because batch 3 failed. Settle all,
  // merge the fulfilled, COUNT the failed (the frame annotates them).
  const settled = await Promise.allSettled(batches.map((b) => monadClient.getChips(slug, b)))
  const fulfilled = settled.filter((s): s is PromiseFulfilledResult<{ chips: Record<string, { kenning: string; icon: string | null; color: string | null }> }> => s.status === 'fulfilled')
  return {
    chips: Object.assign({}, ...fulfilled.map((r) => r.value.chips)),
    failedBatches: settled.length - fulfilled.length,
  }
}
